var _rect, _path, _rect2, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13,
    fill: "#201E26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1759 11.2047H23.2261C22.2421 11.2112 21.3079 10.771 20.6844 10.0069L19.3837 8.19819C18.7706 7.42739 17.8364 6.98508 16.8539 7.00038H14.0616C9.0498 7.00038 7.2002 9.95898 7.2002 14.9898V20.4278C7.19396 21.0259 33.198 21.2437 33.1998 20.6464V19.0653C33.2236 14.0345 32.2593 11.2047 27.1759 11.2047Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 27,
    height: 23,
    rx: 6,
    fill: "#FF3434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.147 15.6284C17.3737 16.1696 15.1389 18.3988 14.592 21.1637C13.5597 26.381 18.2665 30.2703 21.8126 29.7207C22.9621 29.5421 23.5257 28.1973 22.9984 27.1623C22.3539 25.8956 23.2746 24.4169 24.6975 24.4169H26.9211C27.92 24.4169 28.7291 23.591 28.7319 22.595C28.7179 18.198 24.717 14.7384 20.147 15.6284ZM17.1254 24.4169C16.6315 24.4169 16.2325 24.0179 16.2325 23.5241C16.2325 23.0303 16.6315 22.6313 17.1254 22.6313C17.6192 22.6313 18.0182 23.0303 18.0182 23.5241C18.0182 24.0179 17.6192 24.4169 17.1254 24.4169ZM18.0182 20.8457C17.5243 20.8457 17.1254 20.4467 17.1254 19.9529C17.1254 19.459 17.5243 19.0601 18.0182 19.0601C18.512 19.0601 18.911 19.459 18.911 19.9529C18.911 20.4467 18.512 20.8457 18.0182 20.8457ZM21.5894 19.0601C21.0956 19.0601 20.6966 18.6611 20.6966 18.1673C20.6966 17.6734 21.0956 17.2745 21.5894 17.2745C22.0832 17.2745 22.4822 17.6734 22.4822 18.1673C22.4822 18.6611 22.0832 19.0601 21.5894 19.0601ZM25.1606 20.8457C24.6668 20.8457 24.2678 20.4467 24.2678 19.9529C24.2678 19.459 24.6668 19.0601 25.1606 19.0601C25.6545 19.0601 26.0534 19.459 26.0534 19.9529C26.0534 20.4467 25.6545 20.8457 25.1606 20.8457Z",
    fill: "#343843"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8438,
    cy: 23.0938,
    r: 1.09375,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2188,
    cy: 22.2188,
    r: 1.09375,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4688,
    cy: 26.5938,
    r: 1.09375,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7188,
    cy: 19.5938,
    r: 1.09375,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2188,
    cy: 17.8438,
    r: 1.09375,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7188,
    cy: 19.5938,
    r: 1.09375,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon6);
export default __webpack_public_path__ + "static/media/group_icon6.461d2e1c1e1d4a1400c6b627c54e8557.svg";
export { ForwardRef as ReactComponent };